import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicPartnersBusinessGroup({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 80 80"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31 7c-5.523 0-10 4.477-10 10v4h-7C8.477 21 4 25.477 4 31v32c0 5.523 4.477 10 10 10h52c5.523 0 10-4.477 10-10V31c0-5.523-4.477-10-10-10h-7v-4c0-5.523-4.477-10-10-10H31zm20 14v-4a2 2 0 00-2-2H31a2 2 0 00-2 2v4h22zM12 31a2 2 0 012-2h52a2 2 0 012 2v5.394L46 42.26V41a2 2 0 00-2-2h-8a2 2 0 00-2 2v1.26l-22-5.866V31zm22 19.54l-22-5.867V63a2 2 0 002 2h52a2 2 0 002-2V44.673L46 50.54V51a2 2 0 01-2 2h-8a2 2 0 01-2-2v-.46z"
        fill="#F4F5FB"
      />
    </svg>
  );
}

SvgPicPartnersBusinessGroup.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicPartnersBusinessGroup.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicPartnersBusinessGroup svgRef={ref} {...props} />
));
export default ForwardRef;
